export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                FORMS_MANAGE: 'FORMS_MANAGE',
                FORMS_360_MANAGE: 'FORMS_360_MANAGE',
                FORMS_360_REPORT_VIEW: 'FORMS_360_REPORT_VIEW',
                FORMS_SURVEY_MANAGE: 'FORMS_SURVEY_MANAGE',
                FORMS_SURVEY_REPORT_VIEW: 'FORMS_SURVEY_REPORT_VIEW',
                FORMS_SURVEY_CSV_EXPORT: 'FORMS_SURVEY_CSV_EXPORT',
                LICENCE_POINTS_MANAGE: 'LICENCE_POINTS_MANAGE',
                PAST_PERIOD_LICENCE_POINTS_MANAGE: 'PAST_PERIOD_LICENCE_POINTS_MANAGE',
                PERFORMANCE_REVIEW_CONDUCT: 'PERFORMANCE_REVIEW_CONDUCT',
                PERFORMANCE_REVIEW_MANAGE: 'PERFORMANCE_REVIEW_MANAGE',
                REPORTS_LICENCE_POINTS_VIEW: 'REPORTS_LICENCE_POINTS_VIEW',
                REPORTS_LICENCE_POINTS_CSV_EXPORT: 'REPORTS_LICENCE_POINTS_CSV_EXPORT',
                WEBINAR_EMAIL_TEMPLATES_VIEW: 'WEBINAR_EMAIL_TEMPLATES_VIEW',
                APPLICATION_MANAGE: 'APPLICATION_MANAGE',
                EXTERNAL_PARTICIPATIONS_MANAGE: 'EXTERNAL_PARTICIPATIONS_MANAGE',
                TASKLIST_TEMPLATES_MANAGE: 'TASKLIST_TEMPLATES_MANAGE',
                TASKLIST_MANAGE: 'TASKLIST_MANAGE',
                ANALYTICS_VIEW: 'ANALYTICS_VIEW',
                AI_TRANSLATIONS_MANAGE: 'AI_TRANSLATIONS_MANAGE',
                MY_EMPLOYEE_TASKLIST_MANAGE: 'MY_EMPLOYEE_TASKLIST_MANAGE',
                PRECONDITION_LICENCE_POINTS_MANAGE: 'PRECONDITION_LICENCE_POINTS_MANAGE',
                MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW: 'MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW',
                VALIDATIONS_MANAGE: 'VALIDATIONS_MANAGE',
                EVENTS_MANAGE: 'EVENTS_MANAGE',
                EVENTS_ADMINISTRATE: 'EVENTS_ADMINISTRATE',
                USER_SKILL_MANAGE: 'USER_SKILL_MANAGE',
                SKILL_MANAGE: 'SKILL_MANAGE',
                GUIDANCE_MODIFY: 'GUIDANCE_MODIFY',
                PRIVACY_SETTINGS_MANAGE: 'PRIVACY_SETTINGS_MANAGE'
            },
            LABELS: {
                FORMS_MANAGE: $translate.instant('role.companyModulePrivilege.formsManage'),
                FORMS_360_MANAGE: $translate.instant('role.companyModulePrivilege.forms360Manage'),
                FORMS_360_REPORT_VIEW: $translate.instant('role.companyModulePrivilege.forms360ReportView'),
                FORMS_SURVEY_MANAGE: $translate.instant('role.companyModulePrivilege.formsSurveyManage'),
                FORMS_SURVEY_REPORT_VIEW: $translate.instant('role.companyModulePrivilege.formsSurveyReportView'),
                FORMS_SURVEY_CSV_EXPORT: $translate.instant('role.companyModulePrivilege.formsSurveyExportCsv'),
                LICENCE_POINTS_MANAGE: $translate.instant('role.companyModulePrivilege.manageLicencePoints'),
                PAST_PERIOD_LICENCE_POINTS_MANAGE: $translate.instant('role.companyModulePrivilege.managePastPeriodLicencePoints'),
                PERFORMANCE_REVIEW_CONDUCT: $translate.instant('role.companyModulePrivilege.performanceReviewConduct'),
                PERFORMANCE_REVIEW_MANAGE: $translate.instant('role.companyModulePrivilege.performanceReviewManage'),
                REPORTS_LICENCE_POINTS_VIEW: $translate.instant('role.companyModulePrivilege.ReportViewLicencePoints'),
                REPORTS_LICENCE_POINTS_CSV_EXPORT: $translate.instant('role.companyModulePrivilege.ReportExportLicencePoints'),
                WEBINAR_EMAIL_TEMPLATES_VIEW: $translate.instant('role.companyModulePrivilege.WebinarEmailTemplatesView'),
                APPLICATION_MANAGE: $translate.instant('role.companyModulePrivilege.applicationManage'),
                EXTERNAL_PARTICIPATIONS_MANAGE: $translate.instant('role.companyModulePrivilege.externalParticipationsManage'),
                TASKLIST_TEMPLATES_MANAGE: $translate.instant('role.companyModulePrivilege.tasklistTemplatesManage'),
                TASKLIST_MANAGE: $translate.instant('role.companyModulePrivilege.tasklistManage'),
                ANALYTICS_VIEW: $translate.instant('role.privilege.analyticsView'),
                AI_TRANSLATIONS_MANAGE: $translate.instant('role.privilege.aiTranslationsManage'),
                MY_EMPLOYEE_TASKLIST_MANAGE: $translate.instant('role.companyModulePrivilege.myEmployeeTasklistManage'),
                PRECONDITION_LICENCE_POINTS_MANAGE: $translate.instant('role.companyModulePrivilege.preconditionLicencePointsManage'),
                MARKETPLACE_INVOICE_EMAIL_TEMPLATES_VIEW: $translate.instant('role.privilege.marketplaceEmailTemplatesView'),
                VALIDATIONS_MANAGE: $translate.instant('role.privilege.validationsManage'),
                EVENTS_MANAGE: $translate.instant('role.privilege.eventsManage'),
                EVENTS_ADMINISTRATE: $translate.instant('role.privilege.eventsAdministrate'),
                USER_SKILL_MANAGE: $translate.instant('role.privilege.userSkillManage'),
                SKILL_MANAGE: $translate.instant('role.privilege.skillManage'),
                GUIDANCE_MODIFY: $translate.instant('role.privilege.guidanceModify'),
                PRIVACY_SETTINGS_MANAGE: $translate.instant('role.privilege.privacySettingsManage')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });
    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/role/companyModulePrivilege/index.js